import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';

export const Wrapper = styled(Paper)`
  width: 100%;
  box-sizing: border-box;

  .passport-container {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: flex-start;
    width: 100%;
  }

  .passport-left {
    width: 220px;
    flex-shrink: 0;
  }

  .title {
    font-weight: 600;
    font-size: 18px;
    padding-bottom: 5px;
  }

  @media (max-width: 1650px) {
    .passport-container {
      flex-direction: column;
      align-items: center;
    }

    .passport-left {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
    }

    .passport-form {
      width: 100%;
    }
  }
`;
